export default {
  TableHeadMember: [
    [
      {
        displayName: 'dolly.head.no',
        attr: {
          rowspan: 2,
        },
      },
      {
        displayName: 'dolly.head.date',
        attr: {
          rowspan: 2,
          class: 'text-center',
        },
      },
      {
        displayName: 'dolly.head.totalBet',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'houseEdge.member100',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
    ],
  ],
};
